<!--
水揚げ登録画面
URL：unloading/edit
-->

<template>
  <div>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <p class="text-center text-h3">水揚げ</p>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">水揚げ日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                :dateSub="dateSub"
                :events="events"
                :defaultFocus="dateSub"
                @on-update-registration-date="updateRegistrationDate"
                @on-update-calendar-month="updateCalendarEvent"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor2 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">採取海域区分</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" style="margin-top: 32px; margin-bottom: 32px">
              <v-radio-group
                v-model="checkSeaArea"
                class="big-radio-group"
                @change="seaAreaChange"
              >
                <v-radio
                  label="広島湾西部"
                  color="#0ddbc7"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="広島湾北部"
                  color="#0ddbc7"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="広島湾中部"
                  color="#0ddbc7"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="広島湾南部"
                  color="#0ddbc7"
                  :value="4"
                ></v-radio>
                <v-radio
                  label="呉湾"
                  color="#0ddbc7"
                  :value="5"
                ></v-radio>
                <v-radio
                  label="広湾"
                  color="#0ddbc7"
                  :value="6"
                ></v-radio>
                <v-radio
                  label="三津湾"
                  color="#0ddbc7"
                  :value="7"
                ></v-radio>
                <v-radio
                  label="広島県東部"
                  color="#0ddbc7"
                  :value="8"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor3 == 30 }"
        color="card_color3"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">区画漁業権番号</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-menu flat>
                <template v-slot:activator="{ on, attrs }">
                  <v-textarea
                    color="#0ddbc7"
                    readonly
                    v-model="sectionalFisherNumber"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    hide-details="auto"
                    class="text-h5"
                    style="min-height: 30px; overflow: hidden;"
                    :rows="sectionalFisherNumberRowCount"
                    @click="sectionalfisher"
                  ></v-textarea>
                </template>
                <sectionalfisher-number-detail ref="sectionalfisher_number_dtl"
                  :sectionalfisherNumberSelectDialog = "sectionalfisherNumberSelectDialog"
                  :checkSeaArea = "checkSeaArea"
                  :sectionalfisherNumberSelectSub = "sectionalfisherNumberSelectSub"
                  @on-sectionalfisherNumber-select="updateSectionalFisherNumberSelect"
                  @on-sectionalfisherNumber-selected="updateSectionalFisherNumberSelected"
                ></sectionalfisher-number-detail>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">海域区分</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="height: 50px">
              <p class="text-h5">{{ seaareaClass }}</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor4 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">人工浄化</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto">
              <v-radio-group
                row
                v-model="purification"
                class="big-radio-group"
                @change="norovirusCheck"
              >
                <v-radio label="実施" color="#0ddbc7" :value="true"></v-radio>
                <v-radio
                  label="未実施"
                  color="#0ddbc7"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor5 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title"
          >ノロウイルス検査結果</v-card-title
        >
        <v-card-text>
          <v-row>
            <v-col cols="auto">
              <v-radio-group
                row
                v-model="norovirusInsRes"
                class="big-radio-group"
                @change="norovirusCheck"
              >
                <v-radio label="陰性" color="#0ddbc7" :value="false"></v-radio>
                <v-radio label="陽性" color="#0ddbc7" :value="true"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor6 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">貝毒検査結果</v-card-title>
        <v-card-text>
          <v-row v-if="shellpoisonInsResMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="error-message">{{
                shellpoisonInsResMsg
              }}</font>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-radio-group
                v-model="shellpoisonInsRes"
                class="big-radio-group"
                @change="shellpoisonInsResCheck"
              >
                <v-radio label="2MU以下" color="#0ddbc7" :value="1"></v-radio>
                <v-radio label="2～4MU" color="#0ddbc7" :value="2"></v-radio>
                <v-radio label="4MU以上" color="#0ddbc7" :value="3"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-error': cardColor7 == 30 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">食用途</v-card-title>
        <v-card-text>
          <v-row v-if="foodUseMsg" align-content="center">
            <v-col cols="auto" align="left">
              <font color="red" class="error-message">{{ foodUseMsg }}</font>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                class="big-checkbox"
                label="生食用"
                color="#0ddbc7"
                v-model="foodUseRaw"
                @click="foodUseCheck"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto" style="height: 75px">
              <v-checkbox
                class="big-checkbox"
                label="加熱用"
                color="#0ddbc7"
                v-model="foodUseHeating"
                @click="foodUseCheck"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        elevation="5"
        :class="{ 'card-warning': cardColor8 === 20 }"
        class="ma-4"
      >
        <v-card-title class="custom-card-title">水揚げ量</v-card-title>
        <v-card-text>
          <v-row>
            <v-card-subtitle class="custom-card-subtitle">連数</v-card-subtitle>
            <v-col align="right" style="height: 40px">
              <v-text-field
                :Width="12"
                color="#0ddbc7"
                ref="formData.numStations"
                v-model.number="$v.formData.numStations.$model"
                maxlength="8"
                regular
                hide-details="auto"
                dense
                class="text-h6 text-align:center"
                :error-messages="numStationsErrorMessage"
                @change="numStationsMin"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-card-subtitle class="custom-card-subtitle"
              >コレクターの枚数</v-card-subtitle
            >
            <v-col align="right" style="height: 40px">
              <v-text-field
                :Width="12"
                color="#0ddbc7"
                ref="formData.collectNumber"
                v-model.number="$v.formData.collectNumber.$model"
                maxlength="8"
                regular
                hide-details="auto"
                dense
                class="text-h6 text-align:center"
                :error-messages="collectNumberErrorMessage"
                @change="collectNumberMin"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right" style="height: 50px">
              <p class="subtitle-1">合計：{{ totalValue }}枚</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="cancel"
            outlined
            >やめる</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            style="font-size: 24px"
            class="ma-2"
            width="200"
            height="50"
            @click="inputCheck"
            :disabled="!view_status.editable"
            >保存</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- ダイアログ -->
    <confirm-dialog
      ref="confirm_seaArea_change"
      @on-click-ok="initSectionalFisherNumber"
      @on-click-cancel="returnToOldSectionalFisherNumber"
      >選択済の区画漁業権番号を削除します</confirm-dialog
    >
    <!-- 採取海域区分未選択ダイアログ -->
    <confirm-dialog ref="seaArea_unselect_dialog" :singleButton="true"
      >採取海域区分を入力してください</confirm-dialog
    >
    <!-- 入力チェックダイアログ -->
    <confirm-dialog ref="confirm_input_check" @on-click-ok="register">
      <p v-if="shellpoisonInsResMsg">貝毒検査結果:{{ shellpoisonInsResMsg }}</p>
      <p v-if="foodUseMsg">食用途:{{ foodUseMsg }}</p>
      <p v-if="amountMsg">水揚げ量:{{ amountMsg }}</p>
    </confirm-dialog>
  </div>
</template>

<script>
import CustomDatePicker from "../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../logic/common/date-wrapper";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import valueMapper from "../logic/common/value-mapper";
import Validate from "@/logic/common/validate.js";
import SectionalfisherNumberDetail from "../components/unloading-sub-contents/sectionalfisher-number-detail.vue";
import ConfirmDialog from "../components/dialog/confirmWkReg.vue";

const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
const CARD_COLOR_ERROR = 30;

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    "sectionalfisher-number-detail": SectionalfisherNumberDetail,
    "confirm-dialog": ConfirmDialog,
    alert: Alert,
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 連数
      numStations: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
      // コレクターの枚数
      collectNumber: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
    },
  },
  computed: {
    /**
     * 水揚げ量の入力が不正ならtrueを返す
     */
    hasErrorAmount() {
      return Validate.hasError([
        this.$v.formData.numStations,
        this.$v.formData.collectNumber,
      ]);
    },
    /**
     * エラーメッセージ：連数
     */
    numStationsErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.numStations,
        "連数",
        ["singleByteNumber"]
      );
    },
    /**
     * エラーメッセージ：コレクターの枚数
     */
    collectNumberErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.collectNumber,
        "コレクターの枚数",
        ["singleByteNumber"]
      );
    },
    /**
     * 水揚げ量 合計
     */
    totalValue: function () {
      if (!this.hasErrorAmount) {
        return this.formData.numStations * this.formData.collectNumber;
      } else {
        return 0;
      }
    },
    /**
     * 水揚げ量 警告メッセージ
     */
    amountMsg: function () {
      if (this.totalValue === 0) {
        return "生産量の入力が漏れています";
      } else {
        return "";
      }
    },
    /**
     * カード色
     */
    // 採取海域区分
    cardColor2: function () {
      if (this.checkSeaArea === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 区画漁業権番号・海域区分
    cardColor3: function () {
      if (this.seaareaClass === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 人口浄化
    cardColor4: function () {
      if (this.purification === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // ノロウイルス検査結果
    cardColor5: function () {
      if (this.norovirusInsRes === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 貝毒検査結果
    cardColor6: function () {
      if (this.shellpoisonInsRes === "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 食用途
    cardColor7: function () {
      if (this.foodUseRaw == "" && this.foodUseHeating == "") {
        return CARD_COLOR_ERROR;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    // 水揚げ量
    cardColor8: function () {
      if (this.totalValue == 0) {
        return CARD_COLOR_WARNING;
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
  },
  data() {
    var today = new Date();
    let year = today.getFullYear();
    let month = ("0" + (today.getMonth() + 1)).slice(-2);
    let date = ("0" + today.getDate()).slice(-2);
    // api登録用形式の日付
    this.date_api = year + "/" + month + "/" + date;

    // 採取海域区分退避用
    this.checkSeaAreaRsv = ""; //初期値

    // 貝毒検査結果関連メッセージ
    this.shellpoisonInsResMsg = ""; //初期値
    // 食用途関連メッセージ
    this.foodUseMsg = ""; //初期値

    // 区画漁業権番号
    this.sectionalFisherNumber = ""; //初期値
    // 区画漁業権番号項目の高さ
    this.sectionalFisherNumberRowCount = "0"; //初期値
    // API向け区画漁業権番号情報作成
    this.unloadingRightsNumbers = []; //初期値
    // 編集用区画漁業権番号情報作成
    this.sectionalfisherNumberSelectSub = []; //初期値

    // 海域区分の取得設定
    this.seaareaClass = ""; //初期値

    // 水揚げ日補完用 
    this.dateSub = ""; //初期値

    // URLから対象のJSON情報を取得
    this.bodyData = "";
    this.mode = "";
    this.id = "";
    if ((this.$route.params.bodyData) && (this.$route.params.id) && (this.$route.params.mode)) {
      this.bodyData = JSON.parse(decodeURIComponent(this.$route.params.bodyData));

      // 編集時のみ水揚げ日を補完 
      this.mode = JSON.parse(decodeURIComponent(this.$route.params.mode));
      if(this.mode == "EDIT") {
        this.dateSub = this.bodyData.date;
        this.date_api = this.bodyData.date.replace(/-/g, "/");
      }

      this.id = JSON.parse(decodeURIComponent(this.$route.params.id));
    }

    // 新規登録時
    if(this.mode == "") {
      // 最新生産情報補完モードに設定
      this.mode = "LATEST"
      // 最新生産情報取得
      this.bodyData = this.latestSearch();
      // 水揚げ日を補完
      if (this.bodyData) {
        this.dateSub = this.bodyData.date;
        this.date_api = this.bodyData.date.replace(/-/g, "/");
      }
    }

    this.$nextTick(() => {
      this.loadData();
    });

    return {
      sectionalfisherNumberSelectDialog: false,
      events: {},
      menu: "",
      view_status: {
        editable: false,
      },
      errors: [],
      formData: {
        numStations: "",
        collectNumber: "",
      },
      checkSeaArea: "",
      seaareaClass: "",
      purification: "",
      norovirusInsRes: "",
      shellpoisonInsRes: "",
      foodUseRaw: "",
      foodUseHeating: "",
    };
  },
  methods: {
    /**
     * 区画漁業権番号関連
     */
    updateSectionalFisherNumberSelect(sectionalfisherNumberSelect) {
      if (sectionalfisherNumberSelect != null) {
        this.unloadingRightsNumbers = [];
        var numberData = "";
        var rowCount = 0;
        var specCnt = 0;
        var condCnt = 0;
        var notSpecCnt = 0;
        for (const row of sectionalfisherNumberSelect) {
          if (row.number) {
            // 区画漁業権番号項目
            numberData += row.number + "  " + row.name + "\n";

            // API向け区画漁業権番号情報作成
            var unloadingRightsNumbersSub = { unloading_rights_number: "" };
            var unloadingRightsNumber = {
              number: "",
              name: "",
              classification: "",
            };
            unloadingRightsNumber.number = row.number;
            unloadingRightsNumber.name = row.name;

            // 海域区分の分布取得＆情報作成
            switch (row.classification) {
              case "SPECIFIED":
                unloadingRightsNumber.classification = 1;
                specCnt++;
                break;
              case "CONDITIONAL":
                unloadingRightsNumber.classification = 2;
                condCnt++;
                break;
              case "NOT_SPECIFIED":
                unloadingRightsNumber.classification = 3;
                notSpecCnt++;
                break;
              default:
                break;
            }

            // API向け区画漁業権番号の配列情報作成
            unloadingRightsNumbersSub.unloading_rights_number = unloadingRightsNumber;
            this.unloadingRightsNumbers[rowCount++] = unloadingRightsNumbersSub;
          }
        }
        // 区画漁業権番号項目設定
        numberData = numberData.slice(0, -1);
        this.sectionalFisherNumber = numberData;
        this.sectionalFisherNumberRowCount = rowCount;

        // 海域区分の設定
        this.seaareaClass = "";
        if (specCnt != 0) {
          this.seaareaClass += "指定/";
        }
        if (condCnt != 0) {
          this.seaareaClass += "条件付き指定/";
        }
        if (notSpecCnt != 0) {
          this.seaareaClass += "指定外/";
        }
        this.seaareaClass = this.seaareaClass.slice(0, -1);
      }
      // 食用途のエラーメッセージ更新
      this.foodUseCheck();
    },
    /**
     * 区画漁業権番号関連
     */
    updateSectionalFisherNumberSelected(sectionalfisherNumberSelected) {
      this.sectionalfisherNumberSelectDialog = sectionalfisherNumberSelected;
    },

    /**
     * 水揚げ画面にデータを設定する
     */
    setData(data) {
      this.checkSeaArea = data.harvest_sea_area;
      // 採取海域区分退避
      this.checkSeaAreaRsv = this.checkSeaArea;

      if (data.unloading_rights_numbers != null) {
        this.sectionalFisherNumberRowCount = data.unloading_rights_numbers.length;

        var numberData = "";
        var specCnt = 0;
        var condCnt = 0;
        var notSpecCnt = 0;
        var rowCount = 0;

        // 区画漁業権番号項目設定
        for (const row of data.unloading_rights_numbers) {
          if (row.unloading_rights_number.number) {
            var workUnloadingRightsNumbers = {
              classification: "",
              name: "",
              number: "",
            };
            // 一覧内容構築
            workUnloadingRightsNumbers.name = row.unloading_rights_number.name;
            workUnloadingRightsNumbers.number = row.unloading_rights_number.number;
            // 区画漁業権番号選択内容構築
            numberData += row.unloading_rights_number.number + "  " + row.unloading_rights_number.name + "\n";
            // 海域区分の分布取得＆統計作成
            switch (row.unloading_rights_number.classification) {
              case 1:
                workUnloadingRightsNumbers.classification = "SPECIFIED";
                specCnt++;
                break;
              case 2:
                workUnloadingRightsNumbers.classification = "CONDITIONAL";
                condCnt++;
                break;
              case 3:
                workUnloadingRightsNumbers.classification = "NOT_SPECIFIED";
                notSpecCnt++;
                break;
              default:
                break;
            }
            this.sectionalfisherNumberSelectSub[rowCount++] = workUnloadingRightsNumbers;
          }
        }
        numberData = numberData.slice(0, -1);
        this.sectionalFisherNumber = numberData;

        // 海域区分構築
        this.seaareaClass = "";
        if (specCnt != 0) {
          this.seaareaClass += "指定/";
        }
        if (condCnt != 0) {
          this.seaareaClass += "条件付き指定/";
        }
        if (notSpecCnt != 0) {
          this.seaareaClass += "指定外/";
        }
        this.seaareaClass = this.seaareaClass.slice(0, -1);
      }

      this.purification = data.purification;

      if (this.mode == "EDIT") {
        this.norovirusInsRes = data.norovirus;
        this.shellpoisonInsRes = data.poison;
        this.foodUseRaw = data.eat_use_raw;
        this.foodUseHeating = data.eat_use_heating;
        this.formData.numStations = data.amount1;
        if (this.formData.numStations == -1) {
          this.formData.numStations = "";
        }
        this.formData.collectNumber = data.amount2;
        if (this.formData.collectNumber == -1) {
          this.formData.collectNumber = "";
        }
      }
    },
    /**
     * 水揚げ画面関連
     */
    loadData() {
      // APIの実行中は画面を編集不可にする
      this.view_status.editable = false;

      if (this.bodyData) {
        // 画面にデータを設定する
        this.setData(this.bodyData);
      }

      // 画面を編集可能にする
      this.view_status.editable = true;
    },
    /**
     * 登録日を更新する
     */
    updateRegistrationDate(registrationDate) {
      // API指定用登録日
      this.date_api = registrationDate.replace(/-/g, "/");
    },
    /**
     * カレンダーの月間イベント更新
     */
    updateCalendarEvent(registrationDate) {
      this.applyDataToMonthlyArea(registrationDate);
    },
    /**
     * カレンダー表示用月間イベント取得処理
     */
    applyDataToMonthlyArea(date) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.events = {
              unloading: result[mapping.unloading].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              shipping: result[mapping.shipping].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              seawater: result[mapping.seawater].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              worklog: result[mapping.worklog].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
            };
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            if (error.status == 403) {
              this.errors.push(AlertBuilder.error("権限がありません"));
            } else {
              Api.resolve(error);
            }
          });
      });
    },
    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
          Api.call("/admin/user", {
            purpose: "VIEW_HACCP",
          })
        );
      }

      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
        ...[
          Api.call("/work/record", {
            uid: this.$store.getters.userId,
            record_type: "WORKLOG",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SHIPPING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "UNLOADING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$store.getters.userId,
            record_type: "SEAWATER",
            record_date: requestDate,
          }),
        ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },

    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
	
    /**
     * 採取海域区分変更
     */
    seaAreaChange() {
      // 採取海域区分退避
      if (this.checkSeaAreaRsv != "") {
        if (typeof this.$refs.sectionalfisher_number_dtl !== "undefined") {
          // 指定した採取海域区分に合わせて区画漁業権番号一覧画面の内容を取得する
          this.$refs.sectionalfisher_number_dtl.loadData(this.checkSeaArea);
        }
        // 区画漁業権番号項目の設定内容確認
        if (this.sectionalFisherNumber != "") {
          // 採取海域区分変更確認ダイアログを表示する
          this.$refs.confirm_seaArea_change.showDialog();
        } else {
          // 区画漁業権番号関連初期化
          this.initSectionalFisherNumber();
        }
      } else {
        // 採取海域区分退避
        this.checkSeaAreaRsv = this.checkSeaArea;
        if (typeof this.$refs.sectionalfisher_number_dtl !== "undefined") {
          // 指定した採取海域区分に合わせて区画漁業権番号一覧画面の内容を取得する
          this.$refs.sectionalfisher_number_dtl.loadData(this.checkSeaArea);
        }
      }
    },
    /**
     * 区画漁業権番号関連初期化
     */
    initSectionalFisherNumber() {
      // 採取海域区分退避
      this.checkSeaAreaRsv = this.checkSeaArea;
      // 区画漁業権番号項目内容クリア
      this.sectionalFisherNumber = "";
      // 海域区分項目内容クリア
      this.seaareaClass = "";
      // 編集用区画漁業権番号情報作成クリア
      this.sectionalfisherNumberSelectSub = [];
      if (typeof this.$refs.sectionalfisher_number_dtl !== "undefined") {
        // 区画漁業権番号の一覧選択内容クリア
        this.$refs.sectionalfisher_number_dtl.sectionalfisherNumberSelect = [];
      }
    },
    /**
     * 採取海域区分関連更新
     */
    returnToOldSectionalFisherNumber() {
      // 採取海域区分戻し設定
      this.checkSeaArea = this.checkSeaAreaRsv;
    },
    
    /**
     * 区画漁業権番号選択画面を呼び出す
     */
    sectionalfisher() {
      if ("1" <= this.checkSeaArea && this.checkSeaArea <= "8") {
        this.sectionalfisherNumberSelectDialog = true;
      } else {
        // 採取海域区分未選択時はダイアログを表示する
        this.$refs.seaArea_unselect_dialog.showDialog();
      }
    },

    /**
     * ノロウイルス検査結果の入力チェック
     */
    norovirusCheck() {
      // ノロウイルス検査結果更新時に、食用途の入力チェックを行う
      this.foodUseCheck();
    },

    /**
     * 貝毒検査結果の入力チェック
     */
    shellpoisonInsResCheck() {
      if (this.shellpoisonInsRes === "") {
        this.shellpoisonInsResMsg = "";
      } else if (this.shellpoisonInsRes == 1) {
        this.shellpoisonInsResMsg = "";
      } else if (this.shellpoisonInsRes == 2) {
        this.shellpoisonInsResMsg = "";
      } else if (this.shellpoisonInsRes == 3) {
        this.shellpoisonInsResMsg = "「4MU以上」のため、出荷できません";
      }
      // 貝毒検査結果更新時に、食用途の入力チェックを行う
      this.foodUseCheck();
    },

    /**
     * 食用途の入力チェック
     */
    foodUseCheck() {
      if (this.foodUseRaw == "" && this.foodUseHeating == "") {
        this.foodUseMsg = "";
        return;
      }
      if (this.shellpoisonInsRes == 3) {
        //食用途問わず4MU以上
        this.foodUseMsg =
          "貝毒検査結果が「4MU以上」のため、出荷できません";
      } else if (this.foodUseRaw) {
        if (this.norovirusInsRes) {
          this.foodUseMsg =
            "（生食用）ノロウイルス検査結果が「陽性」のため、生食用として出荷できません";
        } else if (this.seaareaClass.match(/指定外/)) {
          this.foodUseMsg =
            "（生食用）海域区分が「指定外」が含まれるため、生食用として出荷できません";
        } else if (
          this.seaareaClass.match(/条件付き指定/) &&
          this.purification === false
        ) {
          this.foodUseMsg =
            "（生食用）海域区分が「条件付き」かつ人工浄化が「未実施」のため、生食用として出荷できません";
        } else {
          this.foodUseMsg = "";
        }
      } else {
        this.foodUseMsg = "";
      }
    },

    /**
     * 水揚げ量・連数最小値設定(0以上)
     */
    numStationsMin() {
      if (this.formData.numStations < 0) {
        this.formData.numStations = 0;
      }
    },
    /**
     * 水揚げ量・コレクターの枚数最小値設定(0以上)
     */
    collectNumberMin() {
      if (this.formData.collectNumber < 0) {
        this.formData.collectNumber = 0;
      }
    },
    /**
     * 格納データを作成する
     */
    buildbodyBodyData() {
      let numStations = this.formData.numStations;
      let collectNumber = this.formData.collectNumber;
      // 食用途(生食用)未選択時の処理
      if (this.foodUseRaw == "") {
        this.foodUseRaw = false;
      }
      // 食用途(加熱用)未選択時の処理
      if (this.foodUseHeating == "") {
        this.foodUseHeating = false;
      }
      // 水揚げ量(連数)未指定時の処理
      if (numStations === "") {
        numStations = -1;
      }
      // 水揚げ量(コレクターの枚数)未指定時の処理
      if (collectNumber === "") {
        collectNumber = -1;
      }
      // 区画漁業権番号情報設定処理
      if (this.unloadingRightsNumbers.length == 0) {
        var rowCount = 0;
        for (const row of this.sectionalfisherNumberSelectSub) {
          if (row.name) {
            var unloadingRightsNumbersSub = { unloading_rights_number: "" };
            var unloadingRightsNumber = {
              number: "",
              name: "",
              classification: "",
            };
            unloadingRightsNumber.name = row.name;
            unloadingRightsNumber.number = row.number;
            // 海域区分の分布取得＆情報作成
            switch (row.classification) {
              case "SPECIFIED":
                unloadingRightsNumber.classification = 1;
                break;
              case "CONDITIONAL":
                unloadingRightsNumber.classification = 2;
                break;
              case "NOT_SPECIFIED":
                unloadingRightsNumber.classification = 3;
                break;
              default:
                break;
            }
            // API向け区画漁業権番号の配列情報作成s
            unloadingRightsNumbersSub.unloading_rights_number = unloadingRightsNumber;
            this.unloadingRightsNumbers[rowCount] = unloadingRightsNumbersSub;
            rowCount++;
          }
        }
      }
      return {
        type: "UNLOADING",
        date: this.date_api,
        harvest_sea_area: this.checkSeaArea,
        unloading_rights_numbers: this.unloadingRightsNumbers,
        purification: this.purification,
        norovirus: this.norovirusInsRes,
        poison: this.shellpoisonInsRes,
        eat_use_raw: this.foodUseRaw,
        eat_use_heating: this.foodUseHeating,
        amount1: numStations,
        amount2: collectNumber,
      };
    },
    /**
     * 登録用送信データを画面から取得する
     */
    buildRegisterData() {
      switch (this.mode) {
        case "EDIT": // 編集
          return {
            record_type: "UNLOADING",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
            record_id: this.workId,
          };
        case "COPY": // コピー
          return {
            record_type: "UNLOADING",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
          };
        default: // 新規
          return {
            record_type: "UNLOADING",
            record_date: this.date_api,
            body: this.buildbodyBodyData(),
          };
      }
    },
    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
      this.clearMessage();
      if (this.hasErrorAmount) {
        this.showMessage(AlertBuilder.error("入力した項目が不正です"));
        return;
      }
      if (
        this.cardColor1 === CARD_COLOR_ERROR ||
        this.cardColor2 === CARD_COLOR_ERROR ||
        this.cardColor3 === CARD_COLOR_ERROR ||
        this.cardColor4 === CARD_COLOR_ERROR ||
        this.cardColor5 === CARD_COLOR_ERROR ||
        this.cardColor6 === CARD_COLOR_ERROR ||
        this.cardColor7 === CARD_COLOR_ERROR
      ) {
        this.showMessage(AlertBuilder.error("必須項目が入力されていません"));
        return;
      }
      if (
        this.shellpoisonInsResMsg != "" ||
        this.foodUseMsg != "" ||
        this.amountMsg != ""
      ) {
        // 入力チェックダイアログを表示する
        this.$refs.confirm_input_check.showDialog();
        return;
      }
      this.register();
    },
    /**
     * 最新生産情報取得用送信データを設定する
     */
    buildLatestSearchData() {
      return {
        uid: this.$store.getters.userId,
        record_type: "UNLOADING",
      };
    },
    /**
     * 取得情報を設定して画面にデータを設定する
     */
    setlatestData(data) {
      this.bodyData = data;
      this.loadData();
    },
    /**
     * 最新生産情報を取得する
     */
    latestSearch() {
      let selectUrl = "";
      let postData = null;

      selectUrl = "/haccp/record/latest";

      postData = this.buildLatestSearchData();

      this.$store.commit("setWaiting", true);

      // APIを実行する
      Api.call(selectUrl, postData)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.setlatestData(result.body);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          // 初回の新規登録時は対象レコードが存在しない為、400が返却されるがエラー扱いとしない
          if ((message.isInvalid) && (error.status != 400)) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    register() {
      // 生産情報登録
      let updateUrl = "";
      let postData = null;

      updateUrl = "/haccp/record/update";
      // 編集時のみid指定
      this.workId = "";
      if (this.mode == "EDIT") {
        this.workId = this.id;
      }
      postData = this.buildRegisterData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/product");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("更新に失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/product");
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
.card-warning {
  background-color: #fff8dc;
}
.card-error {
  background-color: #ffdbe2;
}
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}
.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}
.error-message {
  font-size: 24px;
  line-height: 1.3;
}
.big-checkbox {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
